import React, { useCallback, useEffect, useState } from 'react'
import DialogCustom from '../../../dialog/Dialog'
import { getLogAuditById } from '../../../../services/audit/audit.service'
import Form from './Form/Form'
import DetailAction from './DetailAction'
import BatchUpdate from './BatchUpdate/BatchUpdate'
import { getMaintenanceLogById } from '../../../../services/maintenance/maintenance.service'
import TableCompareImport from './TableCompareImport/TableCompareImport'
import ContentFile from '../../Assessment/LearningContinuum/Import/ContentFile'
import TableCompareImportCurriculumElements from './TableCompareImportCurriculumElements/TableCompareImportCurriculumElements'

const PreviewDialog = ({ show, onClose, type = 'audit' }) => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)

  const loadData = useCallback(async () => {
    if (show) {
      setLoading(true)
      let response = {}
      if (type === 'maintenance') {
        response = await getMaintenanceLogById(show)
      } else if (type === 'audit') {
        response = await getLogAuditById(show)
      }
      setData(response?.data || {})
      setLoading(false)
    }
  }, [show])

  useEffect(() => {
    loadData()
  }, [loadData])

  const actionXL = ['sync seeder']
  const actionMD = ['sync new field']
  const actionXS = ['sync maintenance', 'disable maintenance', 'import', 'export']
  const moduleMD = [
    'learning continuum',
    'developmental rubric',
    'class',
    'marking',
    'data-entry assessment template',
    'data-entry survey template',
    'data-entry assessment',
    'data-entry survey',
    'data-entry my surveys'
  ]

  const moduleXL = ['data-entry assessment marking']
  const maxWidth = actionXS.includes(data?.action)
    ? data?.module === 'learning continuum' && data?.action === 'import'
      ? 'sm'
      : 'xs'
    : actionXL.includes(data?.action) || moduleXL.includes(data?.module)
      ? 'xl'
      : moduleMD.includes(data?.module) || actionMD.includes(data?.action)
        ? 'md'
        : data?.action?.indexOf('batch') > -1
          ? 'md'
          : 'xs'

  return (
    <DialogCustom
      id={`audit-log-preview-${show}`}
      show={!!show}
      title={`Preview ${type} log`}
      onClose={onClose}
      onCloseHeader={true}
      maxWidth={maxWidth}
    >
      <Form form={data} user={data.user} loading={loading} />
      {data?.moduleid && data?.action?.indexOf('batch') === -1 && <DetailAction form={data} />}
      {data?.action?.indexOf('batch') > -1 && <BatchUpdate detail={data.detail} module={data.module} />}
      {!loading && type === 'maintenance' && (
        <TableCompareImport
          data={data?.detail?.data || []}
          status={data?.status}
          description={data?.detail.description}
          type={`${data.module} ${data?.detail?.userType || ''}`}
        />
      )}
      {!loading && data?.module === 'element curriculum' && data?.action === 'import' && (
        <TableCompareImportCurriculumElements data={data?.detail || []} />
      )}
      {!loading && data?.module === 'learning continuum' && data?.action === 'import' && (
        <ContentFile
          contentFile={data?.detail || []}
          columnsHeaders={
            data?.detail?.[0]
              ? Object.keys(data.detail?.[0])
                  .map((key) => key)
                  .filter((key) => !['key', 'isValid', 'error', 'lc', '_version', '_Version'].includes(key))
              : []
          }
          loading={loading}
        />
      )}
    </DialogCustom>
  )
}

export default PreviewDialog
